var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVrsServerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-VRS_server"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VRS_server",
    clipPath: "url(#clip-VRS_server)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2538",
    "data-name": "Rectangle 2538",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_165_electric_wave_A",
    "data-name": "165_electric wave_A",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11052",
    "data-name": "Path 11052",
    d: "M12.5,6.37A1.5,1.5,0,0,0,12,9.28v6.09h1V9.28a1.5,1.5,0,0,0-.5-2.91Z",
    transform: "translate(-5.5 -3.175)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11053",
    "data-name": "Path 11053",
    d: "M20.365,3.12l-.625.78a2.988,2.988,0,0,1,0,4.68l.625.78a3.987,3.987,0,0,0,0-6.24Z",
    transform: "translate(-9.87 -1.55)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11054",
    "data-name": "Path 11054",
    d: "M22.865-.01,22.24.77a4.985,4.985,0,0,1,0,7.8l.625.78a5.994,5.994,0,0,0,0-9.37Z",
    transform: "translate(-11.12 0.02)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    d: "M6.13,3.9l-.625-.78a3.987,3.987,0,0,0,0,6.24l.625-.78a2.988,2.988,0,0,1,0-4.68Z",
    transform: "translate(-2 -1.55)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11056",
    "data-name": "Path 11056",
    d: "M1,4.69A4.986,4.986,0,0,1,2.88.79L2.255.01a5.989,5.989,0,0,0,0,9.365L2.88,8.6A4.986,4.986,0,0,1,1,4.7Z",
    transform: "translate(0 0.005)",
    fill: "#377ef3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVrsServerBlue);
export default __webpack_public_path__ + "static/media/icon_vrs_server_blue.b401b9070e34b326e6ab71c6b05e029f.svg";
export { ForwardRef as ReactComponent };